'use strict';

const Base = require('components/Base/Base');

require('./IndexInnovating.less');

const Selectors = {
    el: '.IndexInnovating',
    title: '.IndexInnovating-title'
};

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        this.options = options;

        setTimeout(() => {
            this.titleObj = {
                $container: this.$(Selectors.title),
                className: 'IndexInnovating-titleLine',
                autoWidth: true
            };
            this.$(Selectors.title).css('opacity', 0);
            app.utils.splitMultilineToSeparateSpans(this.titleObj);
        }, 3000);
    },

    activateSectionShown: function ($el) {
        if (!$el || $el && !$el.is(this.$(Selectors.title))) {
            return;
        }

        this.$(Selectors.title).css('opacity', 1);
        app.utils.animateTextByLines(this.titleObj, {
            lineDuration: 1000,
            lineDelay: 50,
            shift: 30
        });
    }
});
